export default __webpack_public_path__ + "static/media/icon_free_log.8336ebcb.svg";